const MCP_APP_CSP = [
  "default-src 'none'",
  "script-src 'unsafe-inline'",
  "style-src 'unsafe-inline'",
  'img-src data: blob:',
  'font-src data:',
  'media-src data: blob:',
  "connect-src 'none'",
  "form-action 'none'",
  "base-uri 'none'",
].join('; ');

/** Injects a host-owned CSP into untrusted MCP App HTML before srcDoc execution. */
export function sandboxedMcpAppHtml(html: string): string {
  const policy = `<meta http-equiv="Content-Security-Policy" content="${MCP_APP_CSP}">`;
  const head = /<head(?:\s[^>]*)?>/i.exec(html);
  if (head?.index !== undefined) {
    const at = head.index + head[0].length;
    return `${html.slice(0, at)}${policy}${html.slice(at)}`;
  }
  const document = /<html(?:\s[^>]*)?>/i.exec(html);
  if (document?.index !== undefined) {
    const at = document.index + document[0].length;
    return `${html.slice(0, at)}<head>${policy}</head>${html.slice(at)}`;
  }
  return `<!doctype html><html><head>${policy}</head><body>${html}</body></html>`;
}

export { MCP_APP_CSP };
